import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";
import caseStudyService from "../../services/caseStudies/caseStudyService";
import UploadModules from "../../constants/uploadModules";

import "./CaseStudies.css";

export default function CaseStudyForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({

        title: "",

        condition: "",

        duration: "",

        shortDescription: "",

        description: "",

        featuredImage: "",

        beforeImage: "",

        afterImage: "",

        displayOrder: 0

    });


    useEffect(() => {

        if (isEdit) {

            loadCaseStudy();

        }

    }, []);


    const loadCaseStudy = async () => {

        try {

            setLoading(true);

            const response = await caseStudyService.getById(id);

            if (response.success) {

                const data = response.data;

                setForm({

                    title: data.title || "",

                    condition: data.condition || "",

                    duration: data.duration || "",

                    shortDescription: data.shortDescription || "",

                    description: data.description || "",

                    featuredImage: data.featuredImage || "",

                    beforeImage: data.beforeImage || "",

                    afterImage: data.afterImage || "",

                    displayOrder: data.displayOrder || 0

                });

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };


    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm({

            ...form,

            [name]: value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.title.trim()) {

            toast.error("Case Study Title is required.");

            return;

        }

        try {

            setLoading(true);

            let response;

            if (isEdit) {

                response = await caseStudyService.update(id, form);

            }
            else {

                response = await caseStudyService.create(form);

            }

            if (response.success) {

                toast.success(response.message);

                navigate("/case-studies");

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };


    return (

        <AdminLayout>

            <div className="page-header">

                <h2>
                    {isEdit
                        ? "Edit Case Study"
                        : "Add Case Study"}
                </h2>

            </div>


            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">


                            {/* Case Study Title */}

                            <div className="col-lg-6">

                                <label className="form-label">

                                    Case Study Title{" "}

                                    <span className="text-danger">
                                        *
                                    </span>

                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="title"
                                    value={form.title}
                                    onChange={handleChange}
                                />

                            </div>


                            {/* Condition */}

                            <div className="col-lg-3">

                                <label className="form-label">
                                    Condition
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="condition"
                                    value={form.condition}
                                    onChange={handleChange}
                                />

                            </div>


                            {/* Duration */}

                            <div className="col-lg-3">

                                <label className="form-label">
                                    Duration
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="duration"
                                    value={form.duration}
                                    onChange={handleChange}
                                />

                            </div>


                            {/* Short Description */}

                            <div className="col-12">

                                <label className="form-label">
                                    Short Description
                                </label>

                                <textarea
                                    rows="4"
                                    className="form-control"
                                    name="shortDescription"
                                    value={form.shortDescription}
                                    onChange={handleChange}
                                />

                            </div>


                            {/* Description */}

                            <div className="col-12 case-study-description">

                                <label className="form-label">
                                    Description
                                </label>

                                <ReactQuill
                                    theme="snow"
                                    value={form.description}
                                    onChange={(value) =>
                                        setForm({
                                            ...form,
                                            description: value
                                        })
                                    }
                                    placeholder="Enter complete case study description..."
                                />

                            </div>


                            {/* Featured Image */}

                            <div className="col-lg-4">

                                <label className="form-label">
                                    Featured Image
                                </label>

                                <ImageUploader
                                    module={UploadModules.CASE_STUDY}
                                    value={form.featuredImage}
                                    onUpload={(path) =>
                                        setForm({
                                            ...form,
                                            featuredImage: path
                                        })
                                    }
                                />

                            </div>


                            {/* Before Image */}

                            <div className="col-lg-4">

                                <label className="form-label">
                                    Before Image
                                </label>

                                <ImageUploader
                                    module={UploadModules.CASE_STUDY}
                                    value={form.beforeImage}
                                    onUpload={(path) =>
                                        setForm({
                                            ...form,
                                            beforeImage: path
                                        })
                                    }
                                />

                            </div>


                            {/* After Image */}

                            <div className="col-lg-4">

                                <label className="form-label">
                                    After Image
                                </label>

                                <ImageUploader
                                    module={UploadModules.CASE_STUDY}
                                    value={form.afterImage}
                                    onUpload={(path) =>
                                        setForm({
                                            ...form,
                                            afterImage: path
                                        })
                                    }
                                />

                            </div>


                            {/* Display Order */}

                            <div className="col-lg-3">

                                <label className="form-label">
                                    Display Order
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="displayOrder"
                                    value={form.displayOrder}
                                    onChange={handleChange}
                                />

                            </div>


                        </div>


                        <hr />


                        <div className="d-flex justify-content-start gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() =>
                                    navigate("/case-studies")
                                }
                            >
                                Cancel
                            </button>


                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >

                                {loading
                                    ? "Saving..."
                                    : isEdit
                                        ? "Update"
                                        : "Save"}

                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </AdminLayout>

    );

}

